export const EDIT_TYPES = {
  detail: 'detail',
  translations: 'translations',
};
